import { useAgentProfileAvatarModel } from './useAgentProfileAvatarModel.js'
import AgentProfileAvatarView from './AgentProfileAvatarView.jsx'

export default function AgentProfileAvatar(props) {
  return <AgentProfileAvatarView {...useAgentProfileAvatarModel(props)} />
}
